import { type CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { ListBox, Table } from '@flos/react-ui';
import TableRow from '../../../shared_components/TableRow/TableRow';
import { getCoverableWhoIsInsuredConfig } from '../utils/CoverableDetailsWhoIsInsuredUtil';
import TableRowMultipleValues from '../../../shared_components/TableRowMultipleValues/TableRowMultipleValues';
import { useHippoText } from '../../../hooks/useHippoText';
import useWindowSize from '../../../hooks/useWindowSize';

const CoverableDetailsWhoIsInsured = ({
    coverable
}: {
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const { isMobileDevice } = useWindowSize();
    const listBoxIsOpen = isMobileDevice;
    const getHippoText = useHippoText();
    const componentProperties = getCoverableWhoIsInsuredConfig(coverable, getHippoText);
    const coverableProperties = componentProperties?.rowsInformation.filter(
        (rowInfo) => !rowInfo.hidden
    );
    if (!coverable || !coverableProperties || coverableProperties.length === 0) {
        return <></>;
    }
    return (
        <div id="who-is-insured-container" className="u-spacing-inset-m--stretch-max">
            <ListBox title={componentProperties?.title ?? ''} isOpen={!listBoxIsOpen}>
                <Table mobileDirection="horizontal" className="u-spacing-stack-sm">
                    <Table.Body>
                        {coverableProperties.map((rowInfo) => {
                            if (Array.isArray(rowInfo.fieldValue)) {
                                return (
                                    <TableRowMultipleValues rowInfo={rowInfo} key={rowInfo.name} />
                                );
                            }
                            return <TableRow key={rowInfo.name} rowInfo={rowInfo} />;
                        })}
                    </Table.Body>
                </Table>
            </ListBox>
        </div>
    );
};

export default CoverableDetailsWhoIsInsured;
